import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const MESSAGES = [
  "🇨🇦 Is Canada your next business destination?",
  "🌎 Want to take your business global?",
  "📦 Want to sell your products internationally?",
  "💻 Running an online business? Build a global presence.",
  "🏢 Want to open a company in another country?",
  "🤝 Looking for customers, distributors or business partners overseas?",
];

export default function RotatingHeroLine() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % MESSAGES.length), 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="mt-6 max-w-xl" data-testid="hero-rotating-line">
      <div className="min-h-[28px] flex items-center">
        <AnimatePresence mode="wait">
          <motion.span
            key={i}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.5 }}
            className="text-sm md:text-base text-gos-charcoal font-medium"
          >
            {MESSAGES[i]}
          </motion.span>
        </AnimatePresence>
      </div>
      <Link to="/countries" className="mt-1 inline-flex items-center gap-1.5 text-xs text-gos-navy hover:text-gos-maple transition-colors" data-testid="hero-rotating-cta">
        Explore Your Options <ArrowRight size={12} weight="bold" />
      </Link>
    </div>
  );
}
